import * as React from 'react';
import { translate } from '../../helpers';
export var PerkRow = function (_a) {
    var text = _a.text;
    return (React.createElement("div", { className: "perk-row" },
        React.createElement("div", { className: "perk-icon-col" },
            React.createElement("i", { className: "fa-solid fa-check" })),
        React.createElement("div", { className: "perk-description-col" },
            React.createElement("p", null, translate(text)))));
};
